import './styles/contact.css'
import { useEffect, useRef, useState } from "react";
import { EMAIL, PHONE, PHONE_REDIRECT, FULL_NAME, GITHUB_LINK, LINKEDIN_LINK, CONTACT_TITLE } from '../constants.js'



export default function Contact() {

  const cardRef = useRef(null);
  const [isVisible, setIsVisible] = useState(false);

  useEffect(() => {
    const observer = new IntersectionObserver(
      ([entry]) => {
        setIsVisible(entry.isIntersecting);
      },
      { threshold: 0.3 }
    );

    if (cardRef.current) {
      observer.observe(cardRef.current);
    }

    return () => observer.disconnect();
  }, []);

  return (

    <section id="contact" className="section">
      <h1>{"New card... Whaddya think?"}</h1>

      <div
        ref={cardRef}
        className={`business-card ${isVisible ? "show" : ""}`}
      >
        <div className="card-top">
          <a className="phone" href={`tel:${PHONE_REDIRECT}`}>📞 <span>{PHONE}</span></a>
          <a className="email" href={`mailto:${EMAIL}`}>✉️ <span>{EMAIL}</span></a>
        </div>
        <div className="card-middle">
          <h1>{FULL_NAME}</h1>
          <h4>{ CONTACT_TITLE }</h4>
        </div>
        <div className="card-bottom">
          <a href={GITHUB_LINK} target="_blank" rel="noreferrer">
            <img src="./logos/github.svg" alt="GitHub" />
          </a>
          <a href={LINKEDIN_LINK} target="_blank" rel="noreferrer">
            <img src="./logos/linkedin.svg" alt="LinkedIn" />
          </a>
        </div>
      </div>
    </section>
  );
}
